import { render, staticRenderFns } from "./PlanetDefender.vue?vue&type=template&id=ab837f1c&"
import script from "./PlanetDefender.vue?vue&type=script&lang=ts&"
export * from "./PlanetDefender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports